import Vue from 'vue'
import IconSvg from '@/components/SvgIcon'// svg组件

// register globally
Vue.component('IconSvg', IconSvg)

const req = require.context('./svg', false, /\.svg$/)
const iconList = req.keys().map(item => req(item))

export default {
  // 获取图标icon-(*).svg名称列表, 例如[shouye, xitong, zhedie, ...]
  getNameList () {
    return iconList.map(item => item.default.id.replace('icon-', ''))
  }
}



// WEBPACK FOOTER //
// ./src/icons/index.js